export function clientExpenseAmounts(item) {
    const producerInvoice = item.clientChargeType === 'income';
    if (item.isProducerFunded || producerInvoice) {
        return {
            paid: item.clientPaid,
            openBalance: item.clientBalance,
            owedToProducer: true,
            producerInvoice,
        };
    }
    return {
        paid: item.totalPaid,
        openBalance: item.balance,
        owedToProducer: false,
        producerInvoice: false,
    };
}
/** Per-line amounts summed across a client's whole expense list. */
export function sumClientExpenseAmounts(items) {
    let totalCost = 0;
    let totalPaid = 0;
    let openBalance = 0;
    let producerReimbursementDue = 0;
    for (const item of items) {
        const amounts = clientExpenseAmounts(item);
        totalCost += item.price;
        totalPaid += amounts.paid;
        openBalance += amounts.openBalance;
        if (amounts.owedToProducer)
            producerReimbursementDue += amounts.openBalance;
    }
    return { totalCost, totalPaid, openBalance, producerReimbursementDue };
}
//# sourceMappingURL=clientExpense.js.map